/**
 * Kill switch for the Developer page (API keys, docs, sandbox, webhooks).
 * On in every environment, production included; who sees it is per client
 * (hasDeveloperAccess, from the backend). Flip to false to hide it everywhere.
 */
const DEVELOPER_PAGE_ENABLED = true;

export const isDeveloperPageEnabled = (): boolean => DEVELOPER_PAGE_ENABLED;

/**
 * Which client APIs the Developer page shows to a client, from the backend
 * (GET /v1/integration/sandbox-availability → IntegrationAccessContext):
 * `shipments` = the shipment API (docs, sandbox shipments, webhooks),
 * `orders` = the WMS outbound order API and the Warehouse menu.
 */
export interface DeveloperAccess {
  shipments: boolean;
  orders: boolean;
}

/** Nothing shown — while loading, on an error, or without a client. */
export const NO_ACCESS: DeveloperAccess = { shipments: false, orders: false };

export const accessFromAvailability = (availability: {
  shipmentSandbox: boolean;
  wmsSandbox: boolean;
}): DeveloperAccess => ({
  shipments: availability.shipmentSandbox === true,
  orders: availability.wmsSandbox === true,
});

/** The Developer page (API keys, docs, sandbox, webhooks): a client with at
 *  least one API, while the isDeveloperPageEnabled() kill switch is on. */
export const hasDeveloperAccess = (access: DeveloperAccess): boolean =>
  isDeveloperPageEnabled() && (access.shipments || access.orders);

/** The Warehouse menu and /warehouse/* pages: the WMS API. */
export const hasWarehouseAccess = (access: DeveloperAccess): boolean =>
  access.orders;

export const APP_CONFIG = {
  name: 'Link',
  shortName: 'Link',
  subtitle: 'React Web',
  homeRoute: '/deliveries',
  loginTitle: 'Masuk ke akun Anda',
  loginDescription: 'Selamat datang kembali! Silakan masuk untuk melanjutkan.',
  copyright: '© 2026 Dash Electric. All rights reserved',
};
